import { useAppSelector } from "@/stores";

export default function useIsAuthenticated() {
    return useAppSelector(state => Boolean(state.auth.token))
}